import { User } from '../../../../../types/User';
import { Typography } from 'antd';
import '../../style.css';
import './styles.css';

const { Text, Title } = Typography;

export const RecordingAnimation: React.FC<{ isRecording: boolean; user: User }> = ({
    isRecording,
    user,
}) => {
    return (
        <>
            {isRecording ? (
                <div>
                    <div className={'audio-blob-container outgoing'}>
                        <div
                            className={'audio-blob audio-blob-animation'}
                            style={{ backgroundColor: '--bg-surface-hover' }}
                        >
                            <p
                                className={'title medium'}
                                style={{ color: 'var(--gray-01)', height: 24, margin: 0 }}
                            >
                                {user?.name || 'Вы'}
                            </p>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginTop: '16px',
                                    height: 12,
                                    marginLeft: 8,
                                }}
                            >
                                {[1, 2, 3].map((i) => (
                                    <div
                                        key={i}
                                        style={{
                                            width: 8,
                                            height: 8,
                                            borderRadius: '50%',
                                            backgroundColor: 'var(--primary)',
                                            margin: '0 12px 0 0',
                                            animation: `pulse 1s infinite ${i * 0.2}s`,
                                        }}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                ''
            )}
        </>
    );
};
